import Color from "color";
import { logger } from "./loggerHelper";

type ColorValue = string;
type ParsedColor = ReturnType<typeof Color>;

// Helper function to safely create color with fallback
export const createColor = (
  colorValue: ColorValue
): ParsedColor | ColorValue => {
  try {
    return Color(colorValue);
  } catch (error) {
    logger.error(`Invalid color value: ${colorValue}`);
    return colorValue;
  }
};

// Helper function to determine contrast text color
export const getContrastColor = (color: ColorValue) => {
  try {
    return Color(color).isLight() ? "#000000" : "#ffffff";
  } catch (error) {
    logger.error(`Invalid color value: ${color}`);
    return "#ffffff";
  }
};

// Utility function to generate lighter shade of a color
export const generateLighterShade = (colorCode: ColorValue, opacity = 0.2) => {
  // Remove # if present
  const hex = colorCode.replace("#", "");

  // Convert hex to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Return rgba with specified opacity
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// Utility function to generate darker shade for better text contrast
export const generateDarkerShade = (
  colorCode: ColorValue,
  darkenFactor = 0.3
) => {
  // Remove # if present
  const hex = colorCode?.replace("#", "");

  // Convert hex to RGB
  let r = parseInt(hex.substr(0, 2), 16);
  let g = parseInt(hex.substr(2, 2), 16);
  let b = parseInt(hex.substr(4, 2), 16);

  // Darken the color
  r = Math.floor(r * (1 - darkenFactor));
  g = Math.floor(g * (1 - darkenFactor));
  b = Math.floor(b * (1 - darkenFactor));

  // Return hex color
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};
